/**
 * [Editor Guide UI]
 * Explains Save vs Draft vs Publish, and Auto-Save status.
 * Mounted in DaVinciToolbox.
 */
export const DaVinciEditorGuide = {
    render() {
        const div = document.createElement('div');
        div.className = "mt-auto pt-6 border-t border-zinc-800";
        div.innerHTML = `
            <div class="flex items-center gap-2 mb-3">
                <span class="material-symbols-outlined text-zinc-500">help</span>
                <span class="text-xs font-bold text-zinc-500 uppercase">${window.locale.t('davinci.guide.title')}</span>
            </div>
            
            <div class="space-y-2">
                <!-- Save -->
                <div class="bg-zinc-900/50 p-3 rounded-lg border border-zinc-800/50">
                    <div class="flex items-center gap-2 mb-1">
                        <span class="material-symbols-outlined text-sm text-gray-400">save</span>
                        <span class="text-xs font-bold text-gray-300">${window.locale.t('davinci.guide.save')}</span>
                    </div>
                    <p class="text-[10px] text-zinc-500">${window.locale.t('davinci.guide.save_desc')}</p>
                </div>

                <!-- Draft -->
                <div class="bg-zinc-900/50 p-3 rounded-lg border border-zinc-800/50">
                    <div class="flex items-center gap-2 mb-1">
                        <span class="material-symbols-outlined text-sm text-amber-500">lock</span>
                        <span class="text-xs font-bold text-amber-500">${window.locale.t('davinci.guide.draft')}</span>
                    </div>
                    <p class="text-[10px] text-zinc-500"><span class="text-amber-500/80">${window.locale.t('editor.private_toggle') || 'Private'}</span>: ${window.locale.t('davinci.guide.draft_desc')}</p>
                </div>

                <!-- Publish -->
                <div class="bg-zinc-900/50 p-3 rounded-lg border border-zinc-800/50">
                    <div class="flex items-center gap-2 mb-1">
                        <span class="material-symbols-outlined text-sm text-red-500">rocket_launch</span>
                        <span class="text-xs font-bold text-red-500">${window.locale.t('davinci.guide.publish')}</span>
                    </div>
                    <p class="text-[10px] text-zinc-500"><span class="text-red-500/80">${window.locale.t('editor.public_toggle') || 'Public'}</span>: ${window.locale.t('davinci.guide.publish_desc')}</p>
                </div>

                <!-- Auto Save -->
                <div class="bg-zinc-900/50 p-3 rounded-lg border border-blue-900/30">
                    <div class="flex items-center gap-2 mb-1">
                        <span class="material-symbols-outlined text-sm text-blue-400">cloud_done</span>
                        <span class="text-xs font-bold text-blue-400">${window.locale.t('davinci.guide.auto_save')}</span>
                    </div>
                    <p class="text-[10px] text-zinc-500">
                        <span class="text-blue-400 font-bold">${window.locale.t('davinci.guide.auto_save_on')}</span><br>
                        ${window.locale.t('davinci.guide.auto_save_desc')}
                    </p>
                </div>
            </div>
        `;
        return div;
    }
};
